import
  React, {
  useContext,
  useEffect
} from 'react';

import {
  useHistory,
  useLocation
} from 'react-router-dom';

import {
  ColorSvg,
  JourneyProvider,
  Text,
  VFillContainerH
} from '@vodacom/web-common';

import {
  withScreenViewTagging
} from 'hocs';

import {
  PrimaryButton
} from 'components';

import {
  extractDays,
  formatDate,
  generateDynamicMessage,
  getStorageWithExpiry,
  isEqual,
  printCurrency
} from 'helpers';

import {
  CustomColors,
  Icons,
  PaymentOptions,
  PaymentSuccessMessageVariables,
  VoucherAdvanceMessageVariables
} from '../../../../constants';

import {
  CatalogueProvider
} from '../providers';

import {
  AdvanceProvider
} from 'journeys';

import {
  AppContext
} from 'context';

const VoucherAdvanceOrderCompleteUI = () => {

  const history = useHistory();
  const location = useLocation();
  const { config } = useContext(AppContext);
  const urlParams = new URLSearchParams(location?.search);

  const status = urlParams.get('status') === 'true';
  const message = urlParams.get('message');
  const orderId = urlParams.get('orderId');

  const errorMessage = message || 'There was a problem processing your payment. Please try again.';

  let voucherDetails = JourneyProvider.get('Vouchers', 'voucherDetails', null);

  const successTags = {
    event_name:'voucher_advance,journey_end,page_view,transaction_complete',
    journey_step:`cbu: connectu: voucher advance: ${voucherDetails?.category}: purchase complete`,
    journey_name: 'cbu: connectu: voucher advance',
    journey_type : 'transaction',
    product_category: voucherDetails?.category,
    product_id: [ voucherDetails?.product?.name ],
    product_quantity:'1',
    product_price: voucherDetails?.product?.retailPrice,
    voucher_paybackperiod: voucherDetails?.termDuration,
    transaction_method: voucherDetails?.paymentType,
    transaction_id: orderId,
    page_section: 'voucher advance',
    visitor_customer_segment: getStorageWithExpiry('msisdn', 'msisdnType', ''),
    visitor_type: 'consumer',
    visitor_id_asset_active: getStorageWithExpiry('msisdn', 'hashedMsisdn', '')
  };

  const failureTags = {
    event_name: 'voucher_advance,journey_end,page_view,payment_failure',
    journey_step:`cbu: connectu: voucher advance: ${voucherDetails?.category}: purchase failure`,
    journey_name: 'cbu: connectu: voucher advance: purchase failure',
    journey_type: 'transaction',
    page_section: 'voucher advance',
    visitor_customer_segment: getStorageWithExpiry('msisdn', 'msisdnType', ''),
    visitor_type: 'consumer',
    visitor_id_asset_active: getStorageWithExpiry('msisdn', 'hashedMsisdn', '')
  };

  VoucherAdvanceOrderCompleteUI.pageName = `cbu: connectu: voucher advance: ${status ? 'purchase complete' : 'purchase failure'}`;

  VoucherAdvanceOrderCompleteUI.tagViewData = status ? successTags : failureTags;

  const getPageMessage = () => {

    if (!status) {
      return errorMessage;
    }

    if (voucherDetails?.paymentType !== PaymentOptions.Advance.value) {

      return generateDynamicMessage(
        config?.voucherAdvanceConfig?.paymentSuccessMessage,
        {
          [PaymentSuccessMessageVariables.value]: printCurrency(voucherDetails?.product?.normal?.currency)
        }
      );
    }

    const formattedDate = formatDate(new Date().toDateString(), extractDays(voucherDetails?.termDuration));

    return generateDynamicMessage(
      config?.voucherAdvanceConfig?.advanceSuccessMessage,
      {
        [VoucherAdvanceMessageVariables.value]: printCurrency(voucherDetails?.product?.retailPrice),
        [VoucherAdvanceMessageVariables.voucherPaymentDate]: formattedDate
      }
    );
  };

  useEffect(() => {

    CatalogueProvider.purgeVolatileCache();
    AdvanceProvider.purgeVolatileCache();
  }, []);

  return (

    <VFillContainerH
      padding={'14vh 20px 12vh'}>

      <ColorSvg
        src={status ? Icons.CheckmarkCircle : Icons.WarningTriangle}
        color={status ? CustomColors.Green5 : CustomColors.Red2}
        height={'90px'}
        width={'90px'}/>

      <Text
        fontSize={'20px'}
        fontWeight={'500'}
        color={CustomColors.Grey9}
        textAlign={'center'}
        padding={'32px 16px 16px'}>

        {
          status
          ? `${isEqual(voucherDetails?.paymentType, PaymentOptions.Advance.value) ? 'Advance' : 'Payment'} Successful`
          : 'Payment Unsuccessful'
        }
      </Text>

      <Text
        fontSize={'16px'}
        color={CustomColors.Grey9}
        padding={'0 16px'}
        textAlign={'center'}
        dangerouslySetInnerHTML={{
          __html: getPageMessage()
        }}/>

      <VFillContainerH
        width={'100%'}
        justifyContent={'flex-end'}>

        <PrimaryButton
          text={'Okay'}
          onClick={() => {

            history.push('/voucher-advance');
          }}/>
      </VFillContainerH>

    </VFillContainerH>
  );
};

export const VoucherAdvanceOrderComplete = withScreenViewTagging(VoucherAdvanceOrderCompleteUI);